import { createSelector } from "reselect";

import getFloor from "./get_floor";

const getFloorNumber = createSelector([
  getFloor
], (floor) => floor?.floorNumber || null);

export default getFloorNumber;
